export default "__VITE_ASSET__D0k1S7Ec__"